import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiEmployeeRecognition,
  ApiRecognition,
  ApiRecognitionCategory,
  ApiRecognitionCategoryPayload,
  ApiRecognitionHistoryFilter,
  ApiRecognitionMassGiftPayload,
  ApiRecognitionMassGiftPreview,
  ApiRecognitionMassGiftPreviewFilter,
  ApiRecognitionPayload,
} from "@/types/recognitions/recognition.types.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";

export const apiRecognitions = {
  getCategories: () => {
    return api.get<ApiRecognitionCategory[]>("/api/v1/recognitions/categories");
  },
  getCategory: (id: number) => {
    return api.get<ApiRecognitionCategory>(`/api/v1/recognitions/categories/${id}`);
  },
  getRecognitions: (categoryId?: number) => {
    return api.get<ApiRecognition[]>(
      "/api/v1/recognitions",
      categoryId !== undefined ? { category_id: categoryId } : {}
    );
  },
  createRecognition: (payload: ApiRecognitionPayload) => {
    return api.post<ApiRecognition>("/api/v1/recognitions", payload);
  },
  updateRecognition: (id: number, payload: ApiRecognitionPayload) => {
    return api.put<ApiRecognition>(`/api/v1/recognitions/${id}`, payload);
  },
  deleteRecognition: (id: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/recognitions/${id}`);
  },
  sortRecognitions: (ids: number[]) => {
    return api.put<ApiOperationResult>("/api/v1/recognitions/sort", { ids });
  },
  giftRecognition: (payload: ApiRecognitionMassGiftPayload) => {
    return api.post<ApiOperationResult>("/api/v1/recognitions/gift", payload);
  },
  previewGift: (filter: ApiRecognitionMassGiftPreviewFilter) => {
    return api.post<ApiRecognitionMassGiftPreview>("/api/v1/recognitions/gift/preview", filter);
  },
  historySearch: (filter: ApiRecognitionHistoryFilter) => {
    return api.post<ApiPagedData<ApiEmployeeRecognition>>(
      "/api/v1/recognitions/history/search",
      filter
    );
  },
  createCategory: (payload: ApiRecognitionCategoryPayload) => {
    return api.post<ApiRecognitionCategory>("/api/v1/recognitions/categories", payload);
  },
  updateCategory: (id: number, payload: ApiRecognitionCategoryPayload) => {
    return api.put<ApiRecognitionCategory>(`/api/v1/recognitions/categories/${id}`, payload);
  },
  deleteCategory: (id: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/recognitions/categories/${id}`);
  },
  sortCategories: (ids: number[]) => {
    return api.put<ApiOperationResult>("/api/v1/recognitions/categories/sort", { ids });
  },
};
